"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionEnum = void 0;
/**
 * An enum of the physical region the Yext account
 *
 * @remarks
 * Affects the domain the requests are sent to.
 *
 * @public
 */
var RegionEnum;
(function (RegionEnum) {
    RegionEnum["US"] = "US";
    RegionEnum["EU"] = "EU";
})(RegionEnum = exports.RegionEnum || (exports.RegionEnum = {}));
//# sourceMappingURL=Region.js.map